/**
 * Basic listing module
 *
 * @author slanden (slanden@yext.com)
 */
goog.provide('yext.basiclocation');

goog.require('yext');
goog.require('yext.dialog');
goog.require('yext.location.info');
goog.require('yext.notify');

yext.basiclocation.defaultDialogOptions = {
  autoOpen: false,
  modal: true,
  draggable: false,
  resizable: false,
};

/**
 * Initialize this module
 */
yext.basiclocation.init = function() {
  yext.basiclocation.$context = $('.js-basic-location-sidebar');
  yext.basiclocation.$reverifyListingTemplate = $($('.js-reverify-listing-dialog-template').html());
  yext.basiclocation.$phoneVerificationDialog = $('.js-phone-call-verification-dialog');

  yext.basiclocation.bindOptIn();
  yext.basiclocation.bindOptOut();
  yext.basiclocation.bindVerify();
  yext.basiclocation.bindWelcome();
};

/**
 * Binds opening the opt in dialog when the opt-in link is clicked.
 * @suppress {deprecated}
 */
yext.basiclocation.bindOptIn = function() {
  var $optInDialog = $('.js-opt-in-dialog');
  $optInDialog.dialog(
    $.extend({
      title: yext.msg('Opt In Listing'),
      width: 400,
    }, yext.basiclocation.defaultDialogOptions));

  $optInDialog.find('.js-cancel').click(function() {
    $optInDialog.dialog('close');
  });

  $optInDialog.find('.js-opt-in-button').click(function() {
    yext.basiclocation.optIn();
  });

  yext.basiclocation.$context.find('.js-opt-in-link').click(function() {
    $optInDialog.dialog('open');
  });
};

/**
 * Binds opening the opt out dialog when the opt-out link is clicked.
 * @suppress {deprecated}
 */
yext.basiclocation.bindOptOut = function() {
  var $optOutDialog = $('.js-opt-out-dialog');
  $optOutDialog.dialog(
    $.extend({
      title: yext.msg('Opt Out of Listing'),
      width: 400,
    }, yext.basiclocation.defaultDialogOptions));

  $optOutDialog.find('.js-cancel').click(function() {
    $optOutDialog.dialog('close');
  });

  $optOutDialog.find('.js-opt-out-button').click(function() {
    yext.basiclocation.optOut();
  });

  yext.basiclocation.$context.find('.js-opt-out-link').click(function() {
    $optOutDialog.dialog('open');
  });
};

/**
 * Binds opening the verification dialog when the Verify Listing link is clicked.
 * @suppress {deprecated}
 */
yext.basiclocation.bindVerify = function() {
  var $verifyDialog = $('.js-verify-dialog');
  var isFirstVisit = $verifyDialog.data('first');
  var isUnverified = $('.js-unverified-listing').is(':visible');
  var verificationPhoneNumber = $('.js-verify-by-phone-button').data('phone-number');

  if (verificationPhoneNumber) {
    yext.basiclocation.bindPhoneVerification(verificationPhoneNumber);
  }

  $verifyDialog.dialog(
    $.extend({
      width: 680,
      title: isFirstVisit ? yext.msg('Welcome!') : yext.msg('Verify Listing'),
      close: function() {
        $verifyDialog.dialog('option', 'title', yext.msg('Verify Listing'));
        $verifyDialog.find('.inner-container p').text(yext.msg('To complete this process, we need to verify you are the owner of this listing. Please select one of the following verification methods.'));
      },
    }, yext.basiclocation.defaultDialogOptions));

  yext.basiclocation.$context.find('.js-verify-button').click(function() {
    $verifyDialog.dialog('open');
  });

  if (isUnverified) {
    $verifyDialog.dialog('open');
  }
};

/**
 * Binds opening the welcome dialog if the user is an existing Yahoo Claims customer.
 * @suppress {deprecated}
 */
yext.basiclocation.bindWelcome = function() {
  var $welcomeDialog = $('.js-yahoo-welcome-dialog');
  if ($welcomeDialog.length) {
    $welcomeDialog.dialog(
      $.extend({
        width: 400,
        title: yext.msg('Welcome!'),
      }, yext.basiclocation.defaultDialogOptions));

    $welcomeDialog.find('.js-yahoo-welcome-button').click(function() {
      $welcomeDialog.dialog('close');
    });

    $welcomeDialog.dialog('open');
  }
};

/**
 * Opts the location in for its basic listing.
 * @suppress {deprecated}
 * @suppress {deprecated}
 */
yext.basiclocation.optIn = function() {
  var dialogTimeout = yext.dialog.showDelayedProgressDialog();
  $.ajax({
    url: '/s/' + yext.businessId + '/locations/optInBasicLocation',
    data: {
      locationId: yext.location.info.locationId,
    },
    type: 'POST',
    success: function(result) {
      yext.dialog.hideDelayedProgressDialog(dialogTimeout);
      if (result && result.stateError) {
        yext.notify.showError(yext.msg('Initializing location, please try again in a few minutes. Refreshing...'));
        setTimeout(function() {
          window.location.reload();
        }, 2000);
      } else {
        window.location.reload();
      }
    },
    error: function() {
      yext.dialog.hideDelayedProgressDialog(dialogTimeout);
      yext.notify.showError(yext.msg('There was an error while opting in.'));
    },
  });
  $('.js-opt-in-dialog').dialog('close');
};

/**
 * Opts the location out of its basic listing.
 * @suppress {deprecated}
 * @suppress {deprecated}
 */
yext.basiclocation.optOut = function() {
  var dialogTimeout = yext.dialog.showDelayedProgressDialog();
  $.ajax({
    url: '/s/' + yext.businessId + '/locations/optOutBasicLocation',
    data: {
      locationId: yext.location.info.locationId,
    },
    type: 'POST',
    success: function() {
      window.location.reload();
    },
    error: function() {
      yext.dialog.hideDelayedProgressDialog(dialogTimeout);
      yext.notify.showError(yext.msg('There was an error while opting out.'));
    },
  });
  $('.js-opt-out-dialog').dialog('close');
};

/**
 * Binds the verify by phone dialog.
 *
 * @param {string} phoneNumber The phone number to call for verification
 * @suppress {deprecated}
 */
yext.basiclocation.bindPhoneVerification = function(phoneNumber) {
  var $phoneSuccessfulDialog = $('.js-phone-call-successful-dialog');
  var $verifyDialog = $('.js-verify-dialog');
  var $phoneDeclinedDialog = $('.js-phone-declined-dialog');
  var $phoneBlockedDialog = $('.js-phone-blocked-dialog');
  var $verificationCodeInput = yext.basiclocation.$phoneVerificationDialog.find('.js-verification-code');
  var $receiveCallButton = yext.basiclocation.$phoneVerificationDialog.find('.js-receive-call-button');
  var $submitButton = yext.basiclocation.$phoneVerificationDialog.find('.js-submit-phone-verification-button');

  yext.basiclocation.$phoneVerificationDialog.dialog(
    $.extend({
      width: 400,
      title: yext.msg('Answer a Phone Call'),
      close: function() {
        yext.basiclocation.resetDialog(phoneNumber);
      },
    }, yext.basiclocation.defaultDialogOptions));

  yext.basiclocation.$phoneVerificationDialog.find('.js-cancel').click(function() {
    yext.basiclocation.$phoneVerificationDialog.dialog('close');
  });

  $phoneSuccessfulDialog.dialog(
    $.extend({
      width: 400,
      title: yext.msg('Verification Successful'),
      dialogClass: 'phone-call-successful-dialog',
    }, yext.basiclocation.defaultDialogOptions));

  $phoneSuccessfulDialog.find('.js-cancel').click(function() {
    $phoneSuccessfulDialog.dialog('close');
  });

  $phoneDeclinedDialog.dialog(
    $.extend({
      width: 400,
      title: yext.msg('Verification Call Declined'),
      dialogClass: 'phone-declined-dialog',
    }, yext.basiclocation.defaultDialogOptions));

  $phoneDeclinedDialog.find('.js-cancel').click(function() {
    $phoneDeclinedDialog.dialog('close');
  });

  $phoneBlockedDialog.dialog(
    $.extend({
      width: 400,
      title: yext.msg('Phone Number Blocked'),
      dialogClass: 'phone-declined-dialog',
    }, yext.basiclocation.defaultDialogOptions));

  $phoneBlockedDialog.find('.js-cancel').click(function() {
    $phoneBlockedDialog.dialog('close');
  });

  $verifyDialog.find('.js-verify-by-phone-button').click(function() {
    yext.basiclocation.$phoneVerificationDialog.dialog('open');
    $verifyDialog.dialog('close');
  });

  $verificationCodeInput.on('keyup', function() {
    $submitButton.prop('disabled', $verificationCodeInput.val().length != 4);
  });

  $submitButton.click(function() {
    yext.basiclocation.bindPhoneVerificationSubmit(phoneNumber);
  });

  $receiveCallButton.click(function() {
    $verificationCodeInput.removeClass('error');
    yext.basiclocation.makeCall(phoneNumber);
  });
};

/**
 * Handles making the verification phone call and checking the status of the call
 *
 * @param {string} phoneNumber The phone number to call
 * @suppress {deprecated}
 */
yext.basiclocation.makeCall = function(phoneNumber) {
  yext.basiclocation.resetDialog(phoneNumber);
  $.ajax({
    url: '/s/' + yext.businessId + '/locations/makeYahooVerificationCall',
    type: 'POST',
    data: {
      locationId: yext.location.info.locationId,
    },
    success: function(response) {
      if (!response.callHistoryId) {
        yext.notify.showError(yext.msg('There was an error making the verification call. Please try again.'));
        yext.basiclocation.resetDialog(phoneNumber);
      } else {
        yext.basiclocation.callHistoryId = response.callHistoryId;
        yext.basiclocation.$phoneVerificationDialog.find('.js-error').hide();
        yext.basiclocation.$phoneVerificationDialog.find('.js-receive-call-button')
          .prop('disabled', true)
          .text(yext.msg('Calling {0}...', phoneNumber));
        yext.basiclocation.$phoneVerificationDialog.find('.js-verification-code').focus();
        yext.basiclocation.callTimeout = setInterval(yext.basiclocation.getCallStatus(phoneNumber), 3000);
        setTimeout(function() {
          yext.basiclocation.resetDialog(phoneNumber);
        }, 60000);
      }
    },
    error: function(response) {
      yext.notify.showError(yext.msg('There was an error making the verification call. Please try again.'));
      yext.basiclocation.resetDialog(phoneNumber);
    },
  });
};

/**
 * Polls Twilio for the status of the call
 *
 * @param {string} phoneNumber The phone number associated with the claim
 * @suppress {deprecated}
 */
yext.basiclocation.getCallStatus = function(phoneNumber) {
  return function() {
    $.ajax({
      url: '/s/' + yext.businessId + '/locations/getVerificationCallStatus',
      type: 'GET',
      data: {
        callHistoryId: yext.basiclocation.callHistoryId,
      },
      success: function(response) {
        var status = response;
        if (status == 'NO_ANSWER') {
          yext.basiclocation.resetDialog(phoneNumber);
          yext.basiclocation.$phoneVerificationDialog.find('.js-no-answer').show();
        } else if (status == 'PIN_DELIVERED') {
          yext.basiclocation.resetDialog(phoneNumber);
        } else if (status == 'DECLINED') {
          yext.basiclocation.handleBlockedPhone(phoneNumber);
          $('.js-phone-declined-dialog').dialog('open');
        }
      },
    });
  };
};

/**
 * Binds the action on submitting the verification code
 *
 * @param {string} phoneNumber The phone number associated with the claim
 * @suppress {deprecated}
 * @suppress {deprecated}
 */
yext.basiclocation.bindPhoneVerificationSubmit = function(phoneNumber) {
  $.ajax({
    url: '/s/' + yext.businessId + '/locations/submitVerificationCode',
    type: 'POST',
    data: {
      locationId: yext.location.info.locationId,
      callHistoryId: yext.basiclocation.callHistoryId,
      code: yext.basiclocation.$phoneVerificationDialog.find('.js-verification-code').val(),
    },
    success: function(response) {
      if (response == 'Match') {
        yext.basiclocation.resetDialog(phoneNumber);
        $('.js-unverified-listing').hide();
        $('.js-submitted-listing').show();
        yext.basiclocation.$phoneVerificationDialog.dialog('close');
        $('.js-phone-call-successful-dialog').dialog('open');
      } else if (response == 'NoMatch') {
        yext.basiclocation.handleWrongCode();
      } else if (response == 'Blocked') {
        yext.basiclocation.handleBlockedPhone(phoneNumber);
        $('.js-phone-blocked-dialog').dialog('open');
      }
    },
    error: function(response) {
      yext.notify.showError(yext.msg('There was an error submitting the verification code. Please try again'));
    },
  });
};

/**
 * Clears the interval that polls Twilio and re-enables the make call button
 *
 * @param {string} phoneNumber The phone number to call
 */
yext.basiclocation.resetDialog = function(phoneNumber) {
  clearInterval(yext.basiclocation.callTimeout);
  yext.basiclocation.$phoneVerificationDialog.find('.js-receive-call-button')
    .prop('disabled', false)
    .text(yext.msg('Receive Call at {0}', phoneNumber));
};

/**
 * Handles the case when the user inputs the wrong code
 */
yext.basiclocation.handleWrongCode = function() {
  yext.basiclocation.$phoneVerificationDialog.find('.js-submit-phone-verification-button').prop('disabled', true);
  yext.basiclocation.$phoneVerificationDialog.find('.js-wrong-code').show();
  yext.basiclocation.$phoneVerificationDialog.find('.js-verification-code').addClass('error');
};

/**
 * Handles the case when the phone number is blocked because the user declined our
 * call or entered an incorrect code too many times.
 *
 * @param {string} phoneNumber The phone number associated with the claim
 * @suppress {deprecated}
 */
yext.basiclocation.handleBlockedPhone = function(phoneNumber) {
  var $verifyDialog = $('.js-verify-dialog');
  yext.basiclocation.resetDialog(phoneNumber);
  yext.basiclocation.$phoneVerificationDialog.dialog('close');
  $verifyDialog.find('.js-phone-verification-section').remove();
  $verifyDialog.find('.js-buttons-container').removeClass('three-options');
  yext.basiclocation.$phoneVerificationDialog.remove();
};
